module.exports = __webpack_public_path__ + "img/mexico864.ec080d8d.jpg";